import {
  type AiTakeAVideoConfig,
  AttendanceVerificationMethod,
  type AttendanceVerificationMethodConfig,
  type TakeAVideoConfig as TakeAVideoConfigType,
} from "@clipboard-health/contract-backend-main";
import { Box, Stack } from "@mui/material";

import {
  getModelsForOption,
  getSelectedValidationModelOption,
  timeclockLocationStringSchema,
  VALIDATION_MODEL_OPTIONS,
  validationModelOptionSchema,
  type ValidationModelOptionValue,
} from "../types";
import { SaveableSelect } from "./SaveableSelect";
import { SaveableTextField } from "./SaveableTextField";

interface TakeAVideoConfigProps {
  method: TakeAVideoConfigType | AiTakeAVideoConfig;
  onSave: (config: AttendanceVerificationMethodConfig) => void;
}

export function TakeAVideoConfig(props: TakeAVideoConfigProps) {
  const { method, onSave } = props;

  return (
    <Stack spacing={3}>
      <Box>
        <SaveableTextField
          label="Time clock location"
          value={method.timeclockLocationString ?? ""}
          placeholder="In the room with the copier"
          schema={timeclockLocationStringSchema}
          onSave={async (value: string) => {
            onSave({
              ...method,
              timeclockLocationString: value,
            });
          }}
        />
      </Box>

      {method.type === AttendanceVerificationMethod.AI_TAKE_A_VIDEO && (
        <Box>
          <SaveableSelect
            label="Validation model"
            value={getSelectedValidationModelOption(method)}
            options={VALIDATION_MODEL_OPTIONS.map(({ label, value }) => ({ label, value }))}
            schema={validationModelOptionSchema}
            onSave={(selectedOption: string) => {
              onSave({
                ...method,
                validationModels: getModelsForOption(selectedOption as ValidationModelOptionValue),
              });
            }}
          />
        </Box>
      )}
    </Stack>
  );
}
